import { FunctionComponent, useState } from 'react';

import { Stack } from '@mui/material';

import { Button, Modal } from '@dw/components/core';
import { QuickCreateDanceSchoolForm } from './QuickCreateDanceSchoolForm';

interface ICreateNewDanceSchoolModalProps {
  open: boolean;
  onClose: () => void;
}
export const CreateNewDanceSchoolModal: FunctionComponent<ICreateNewDanceSchoolModalProps> = (props: ICreateNewDanceSchoolModalProps) => {

  const {
    open,
    onClose
  } = props;

  const [isSavingForm, setIsSavingForm] = useState(false);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Create New School'
    >
      <Stack direction="column" rowGap={4}>
        <QuickCreateDanceSchoolForm
          loadingStatusChanged={setIsSavingForm}
          onSaved={onClose}
        />

        <Button
          variant='text'
          size="small"
          onClick={onClose}
          disabled={isSavingForm}
        >
          Cancel
        </Button>
      </Stack>
    </Modal>
  )
}